module.exports = __webpack_public_path__ + "static/media/waterpark4.cd30f19f.jpg";